import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'clpFormat'
})
export class ClpFormatPipe implements PipeTransform {

  transform(value: number | string | undefined): string {
    if (value === undefined || value === null || value === '') return '$0';

    const numericValue = typeof value === 'string' ? parseFloat(value) : value;
    if (isNaN(numericValue)) return '$0';

    return new Intl.NumberFormat('es-CL', {
      style: 'currency',
      currency: 'CLP',
      minimumFractionDigits: 0
    }).format(numericValue).replace('CLP', '').trim();
  }
}
